import {
    apiRequest,
    orangtuaDetail,
    orangtuaUpdate,
    masterRegion
} from "../../../../../../services/adapters/kepegawaian/orangtuaService"

class UpdateRepository {

    fetchRegionCountries = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", orangtuaDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", orangtuaUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository